import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/caprock/images/close.svg'
import _imports_1 from '../../assets/caprock/images/plus.svg'
import _imports_2 from '../../assets/caprock/images/minus.svg'


const _withScopeId = n => (_pushScopeId("data-v-d62a9644"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row my-3 justify-content-center"
}
const _hoisted_2 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_3 = { class: "login-card" }
const _hoisted_4 = { class: "login-body company" }
const _hoisted_5 = { class: "row mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
    /*#__PURE__*/_createElementVNode("h4", { style: {"color":"grey","font-family":"'Merriweather'"} }, " Beneficiaries "),
    /*#__PURE__*/_createElementVNode("p", { class: "mt-4 mb-4 font-grey" }, [
      /*#__PURE__*/_createTextVNode(" Each of the listed beneficiaries below will receive email with the registration link to complete the caprock Individual Application Form."),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" The beneficiaries and the company will not be activated unless all the beneficiaries have successfully completed and submitted their individual application form. ")
    ])
  ])
], -1))
const _hoisted_7 = { class: "col-md-12 col-12 table-responsive" }
const _hoisted_8 = { class: "table table-bordered w-100" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "Name"),
    /*#__PURE__*/_createElementVNode("th", null, "Email"),
    /*#__PURE__*/_createElementVNode("th", null, "Phone No"),
    /*#__PURE__*/_createElementVNode("th", null, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "Action")
  ])
], -1))
const _hoisted_10 = ["id"]
const _hoisted_11 = { class: "text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_0
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "beneficiaryC"
}
const _hoisted_17 = { colspan: "6" }
const _hoisted_18 = { style: {"color":"grey","font-family":"Merriweather"} }
const _hoisted_19 = { class: "form-group d-none" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "How many directors / partners are in the organisation. ", -1))
const _hoisted_21 = {
  key: 0,
  class: "table table-bordered w-100"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "No"),
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Email"),
  /*#__PURE__*/_createElementVNode("th", null, "Phone No"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, " Action ")
], -1))
const _hoisted_23 = ["id"]
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "text-center" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"height":"1.5rem"},
  src: _imports_0
}, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "5",
  class: "text-center"
}, "No managing members found", -1))
const _hoisted_31 = [
  _hoisted_30
]
const _hoisted_32 = {
  key: 1,
  class: "text-right w-100",
  style: {"color":"#6B7A99"}
}
const _hoisted_33 = { class: "row my-3 justify-content-center" }
const _hoisted_34 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_35 = { class: "login-card" }
const _hoisted_36 = { class: "login-body company" }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6 col-6" }
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_41 = { class: "col-md-6 col-6" }
const _hoisted_42 = { class: "form-group" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_44 = { class: "col-md-6 col-6" }
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_47 = {
  key: 0,
  class: "col-md-6 col-6"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-success btn-mobile btn-sm mt-3 btn-mobile font-size-15-18"
  }, " Save Member ")
], -1))
const _hoisted_49 = { class: "col-md-12 col-12 d-none" }
const _hoisted_50 = { class: "form-group" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Please select the member who will be receiving all company's communication.", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_53 = ["value"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "6",
  class: "text-center"
}, "No records found", -1))
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = {
  class: "text-right w-100",
  style: {"color":"#6B7A99"}
}
const _hoisted_58 = { class: "row my-3 justify-content-center" }
const _hoisted_59 = { class: "col-12 col-sm-12 col-md-10 offset-md-1 col-lg-10 offset-lg-1 col-xl-8 offset-xl-3" }
const _hoisted_60 = { class: "login-card" }
const _hoisted_61 = { class: "login-body company" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-md-6 col-6" }
const _hoisted_64 = { class: "form-group" }
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Type", -1))
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Indvidual", -1))
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Corporate", -1))
const _hoisted_68 = {
  key: 0,
  class: "col-md-6 col-6"
}
const _hoisted_69 = { class: "form-group" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Company Type", -1))
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Please select", -1))
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Australian Domestic Company", -1))
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "ASIC registered Non-Australian Company", -1))
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Non-Australian Company", -1))
const _hoisted_75 = { class: "col-md-6 col-6" }
const _hoisted_76 = { class: "form-group" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Name", -1))
const _hoisted_78 = { class: "col-md-6 col-6" }
const _hoisted_79 = { class: "form-group" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Email", -1))
const _hoisted_81 = { class: "col-md-6 col-6" }
const _hoisted_82 = { class: "form-group" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "font-grey" }, "Phone Number", -1))
const _hoisted_84 = {
  key: 1,
  class: "col-md-6 col-6"
}
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 col-12 d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "subBtn btn btn-success btn-mobile mt-3 btn-mobile font-size-15-18"
  }, " Save Beneficiary ")
], -1))
const _hoisted_86 = {
  class: "modal fade delete_beneficiary",
  id: "delete_beneficiary",
  role: "dialog"
}
const _hoisted_87 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_88 = {
  class: "modal-content",
  style: {"border":"1px solid grey","border-radius":"6px"}
}
const _hoisted_89 = { class: "modal-body mb-2" }
const _hoisted_90 = { class: "row mx-1 mt-1" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Removing beneficiary will erase all details of this beneficiary.")
], -1))
const _hoisted_92 = { class: "col-md-12 text-right" }
const _hoisted_93 = {
  class: "modal fade delete_director",
  id: "delete_director",
  role: "dialog"
}
const _hoisted_94 = {
  class: "modal-dialog modal-md modal-dialog-centered",
  role: "document"
}
const _hoisted_95 = {
  class: "modal-content",
  style: {"border":"1px solid grey","border-radius":"6px"}
}
const _hoisted_96 = { class: "modal-body mb-2" }
const _hoisted_97 = { class: "row mx-1 mt-1" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("p", { style: {"font-size":"larger"} }, "Removing director will erase all details of this director.")
], -1))
const _hoisted_99 = { class: "col-md-12 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.beneficiaries.length>0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("table", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.beneficiaries, (beneficiary, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: beneficiary.beneficiary_id
                          }, [
                            _createElementVNode("tr", {
                              id: 'beneficiary_'+beneficiary.beneficiary_id
                            }, [
                              _createElementVNode("td", _hoisted_11, _toDisplayString(index+1), 1),
                              _createElementVNode("td", null, _toDisplayString(beneficiary['beneficiary_name']), 1),
                              _createElementVNode("td", null, _toDisplayString(beneficiary['beneficiary_email']), 1),
                              _createElementVNode("td", null, _toDisplayString(beneficiary['beneficiary_phone_no']), 1),
                              _createElementVNode("td", null, _toDisplayString(beneficiary['beneficiary_type']), 1),
                              _createElementVNode("td", _hoisted_12, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => {_ctx.ask_delete(beneficiary.beneficiary_id);},
                                  class: "btn-mobile btn"
                                }, _hoisted_15, 8, _hoisted_13)
                              ])
                            ], 8, _hoisted_10),
                            (_ctx.show_Tdirectors==beneficiary.beneficiary_id)
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                                  _createElementVNode("td", _hoisted_17, [
                                    _createElementVNode("h6", _hoisted_18, " Managing Members (" + _toDisplayString(beneficiary['beneficiary_name']) + ") ", 1),
                                    _createElementVNode("div", _hoisted_19, [
                                      _hoisted_20,
                                      _createVNode(_component_Field, {
                                        modelValue: _ctx.form.no_of_directors,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.no_of_directors) = $event)),
                                        placeholder: "i.e. 2 ",
                                        class: "form-control selected-field",
                                        name: "no_of_directors",
                                        type: "text",
                                        rules: _ctx.requiredField
                                      }, null, 8, ["modelValue", "rules"]),
                                      _createVNode(_component_ErrorMessage, {
                                        style: {"color":"#d00000"},
                                        name: "no_of_directors"
                                      })
                                    ]),
                                    (beneficiary['directors'].length)
                                      ? (_openBlock(), _createElementBlock("table", _hoisted_21, [
                                          _createElementVNode("tbody", null, [
                                            _hoisted_22,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(beneficiary['directors'], (director, index) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: director.director_id,
                                                id: 'beneficiary_director_'+beneficiary.beneficiary_id
                                              }, [
                                                _createElementVNode("td", _hoisted_24, _toDisplayString(index+1), 1),
                                                _createElementVNode("td", null, _toDisplayString(director['director_name']), 1),
                                                _createElementVNode("td", null, _toDisplayString(director['director_email']), 1),
                                                _createElementVNode("td", null, _toDisplayString(director['director_phone_no']), 1),
                                                _createElementVNode("td", _hoisted_25, [
                                                  _createElementVNode("button", {
                                                    type: "button",
                                                    onClick: ($event: any) => {_ctx.ask_director_delete(director.director_id,beneficiary.beneficiary_id);},
                                                    class: "btn-mobile btn"
                                                  }, _hoisted_28, 8, _hoisted_26)
                                                ])
                                              ], 8, _hoisted_23))
                                            }), 128)),
                                            (typeof beneficiary['directors']=='undefined' || !beneficiary['directors'].length)
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_29, _hoisted_31))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (beneficiary['directors'].length)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                          _createTextVNode(" Do you want to add another member "),
                                          _createElementVNode("img", {
                                            class: "pl-2 mr-3",
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (this.show_dir_form=1)),
                                            style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                                            src: _imports_1
                                          })
                                        ]))
                                      : _createCommentVNode("", true),
                                    ((typeof beneficiary['directors']=='undefined' || beneficiary['directors'].length==0) || (_ctx.show_dir_form==1 && beneficiary.beneficiary_id==this.active_beneficiary_id))
                                      ? (_openBlock(), _createBlock(_component_Form, {
                                          key: 2,
                                          ref_for: true,
                                          ref: 'director_form_'+beneficiary.beneficiary_id,
                                          id: 'director_form_'+beneficiary.beneficiary_id,
                                          method: "POST",
                                          action: "/",
                                          class: "my-1 card p-2",
                                          onSubmit: _ctx.save_director
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", _hoisted_33, [
                                              _createElementVNode("div", _hoisted_34, [
                                                _createElementVNode("div", _hoisted_35, [
                                                  _createElementVNode("div", _hoisted_36, [
                                                    _createElementVNode("div", _hoisted_37, [
                                                      _createElementVNode("div", _hoisted_38, [
                                                        _createElementVNode("div", _hoisted_39, [
                                                          _hoisted_40,
                                                          _createVNode(_component_Field, {
                                                            modelValue: _ctx.form.director_name,
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.director_name) = $event)),
                                                            placeholder: "i.e. Jonaten ",
                                                            class: "form-control selected-field",
                                                            name: "beneficiary_name",
                                                            type: "text",
                                                            rules: _ctx.requiredField
                                                          }, null, 8, ["modelValue", "rules"]),
                                                          _createVNode(_component_ErrorMessage, {
                                                            style: {"color":"#d00000"},
                                                            name: "beneficiary_name"
                                                          })
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_41, [
                                                        _createElementVNode("div", _hoisted_42, [
                                                          _hoisted_43,
                                                          _createVNode(_component_Field, {
                                                            modelValue: _ctx.form.director_email,
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.director_email) = $event)),
                                                            placeholder: "i.e. email@address.com  ",
                                                            class: "form-control selected-field",
                                                            name: "beneficiary_email",
                                                            type: "text",
                                                            rules: [_ctx.requiredField,_ctx.validateEmail]
                                                          }, null, 8, ["modelValue", "rules"]),
                                                          _createVNode(_component_ErrorMessage, {
                                                            style: {"color":"#d00000"},
                                                            name: "beneficiary_email"
                                                          })
                                                        ])
                                                      ]),
                                                      _createElementVNode("div", _hoisted_44, [
                                                        _createElementVNode("div", _hoisted_45, [
                                                          _hoisted_46,
                                                          _createVNode(_component_Field, {
                                                            modelValue: _ctx.form.director_phone_no,
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.director_phone_no) = $event)),
                                                            placeholder: "i.e. 3539 000556  ",
                                                            class: "form-control selected-field",
                                                            name: "beneficiary_phone_no",
                                                            type: "text",
                                                            rules: [_ctx.requiredField,_ctx.mobileField]
                                                          }, null, 8, ["modelValue", "rules"]),
                                                          _createVNode(_component_ErrorMessage, {
                                                            style: {"color":"#d00000"},
                                                            name: "beneficiary_phone_no"
                                                          })
                                                        ])
                                                      ]),
                                                      (_ctx.beneficiaries.length>0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                                            _createElementVNode("img", {
                                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (this.show_dir_form=0)),
                                                              style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                                                              src: _imports_2
                                                            })
                                                          ]))
                                                        : _createCommentVNode("", true),
                                                      _hoisted_48
                                                    ])
                                                  ])
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1032, ["id", "onSubmit"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", _hoisted_50, [
                                        _hoisted_51,
                                        _createVNode(_component_Field, {
                                          modelValue: _ctx.form.default_recipient,
                                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.default_recipient) = $event)),
                                          class: "form-control",
                                          name: "default_recipient",
                                          as: "select",
                                          rules: _ctx.selectField
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_52,
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(beneficiary['directors'], (director) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                value: director.director_id,
                                                key: director.beneficiary_id
                                              }, _toDisplayString(director['director_name']) + " (" + _toDisplayString(director['director_email']) + ")", 9, _hoisted_53))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "rules"]),
                                        _createVNode(_component_ErrorMessage, {
                                          style: {"color":"#d00000"},
                                          name: "default_recipient"
                                        })
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128)),
                        (!_ctx.beneficiaries.length)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_54, _hoisted_56))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_57, [
                    _createTextVNode(" Do you want to add another beneficiary "),
                    _createElementVNode("img", {
                      class: "pl-2 mr-3",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (this.show_form=1)),
                      style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                      src: _imports_1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.beneficiaries.length==0 || _ctx.show_form==1)
      ? (_openBlock(), _createBlock(_component_Form, {
          key: 1,
          ref: "beneficiary_form",
          id: "beneficiary_form",
          method: "POST",
          action: "/",
          class: "my-1 card p-2",
          onSubmit: _ctx.save_beneficiary
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _hoisted_65,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.beneficiary_type,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.beneficiary_type) = $event)),
                            class: "form-control",
                            name: "beneficiary_type",
                            as: "select",
                            rules: _ctx.selectField
                          }, {
                            default: _withCtx(() => [
                              _hoisted_66,
                              _hoisted_67
                            ]),
                            _: 1
                          }, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "beneficiary_type"
                          })
                        ])
                      ]),
                      (_ctx.form.beneficiary_type==2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                            _createElementVNode("div", _hoisted_69, [
                              _hoisted_70,
                              _createVNode(_component_Field, {
                                modelValue: _ctx.form.company_type,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.company_type) = $event)),
                                class: "form-control",
                                name: "company_type",
                                as: "select",
                                rules: _ctx.selectField
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_71,
                                  _hoisted_72,
                                  _hoisted_73,
                                  _hoisted_74
                                ]),
                                _: 1
                              }, 8, ["modelValue", "rules"]),
                              _createVNode(_component_ErrorMessage, {
                                style: {"color":"#d00000"},
                                name: "company_type"
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _hoisted_77,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.beneficiary_name,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.beneficiary_name) = $event)),
                            placeholder: "i.e. Jonaten ",
                            class: "form-control selected-field",
                            name: "beneficiary_name",
                            type: "text",
                            rules: _ctx.requiredField
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "beneficiary_name"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_78, [
                        _createElementVNode("div", _hoisted_79, [
                          _hoisted_80,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.beneficiary_email,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.beneficiary_email) = $event)),
                            placeholder: "i.e. email@address.com  ",
                            class: "form-control selected-field",
                            name: "beneficiary_email",
                            type: "text",
                            rules: [_ctx.requiredField,_ctx.validateEmail]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "beneficiary_email"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_81, [
                        _createElementVNode("div", _hoisted_82, [
                          _hoisted_83,
                          _createVNode(_component_Field, {
                            modelValue: _ctx.form.beneficiary_phone_no,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.beneficiary_phone_no) = $event)),
                            placeholder: "i.e. 3539 000556  ",
                            class: "form-control selected-field",
                            name: "beneficiary_phone_no",
                            type: "text",
                            rules: [_ctx.requiredField,_ctx.mobileField]
                          }, null, 8, ["modelValue", "rules"]),
                          _createVNode(_component_ErrorMessage, {
                            style: {"color":"#d00000"},
                            name: "beneficiary_phone_no"
                          })
                        ])
                      ]),
                      (_ctx.beneficiaries.length>0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                            _createElementVNode("img", {
                              onClick: _cache[13] || (_cache[13] = ($event: any) => (this.show_form=0)),
                              style: {"float":"right","cursor":"pointer","height":"1.7rem"},
                              src: _imports_2
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _hoisted_85
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["onSubmit"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_86, [
      _createElementVNode("div", _hoisted_87, [
        _createElementVNode("div", _hoisted_88, [
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _hoisted_91,
              _createElementVNode("div", _hoisted_92, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.delete_beneficiary(_ctx.active_beneficiary_id)))
                }, "Remove"),
                _createElementVNode("button", {
                  onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.closeModal('delete_beneficiary'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_93, [
      _createElementVNode("div", _hoisted_94, [
        _createElementVNode("div", _hoisted_95, [
          _createElementVNode("div", _hoisted_96, [
            _createElementVNode("div", _hoisted_97, [
              _hoisted_98,
              _createElementVNode("div", _hoisted_99, [
                _createElementVNode("button", {
                  class: "ok_btn",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.delete_director(_ctx.active_director_id,_ctx.active_beneficiary_id)))
                }, "Remove"),
                _createElementVNode("button", {
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.closeModal('delete_director'))),
                  class: "cancel_btn ml-2"
                }, "Cancel")
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}